module.exports = __webpack_public_path__ + "img/chess_japanchess13.9e0e8717.png";